export function createEphemeralStore() {
  const map = new Map()

  const get = (key) => (map.has(key) ? map.get(key) : null)
  const set = (key, value) => {
    map.set(key, value)
  }
  const remove = (key) => {
    map.delete(key)
  }
  const clear = () => {
    map.clear()
  }

  const getJson = (key, fallback) => {
    const raw = get(key)
    if (raw == null) return fallback
    try {
      return JSON.parse(String(raw))
    } catch {
      return fallback
    }
  }

  const setJson = (key, value) => {
    try {
      set(key, JSON.stringify(value))
    } catch {
      set(key, null)
    }
  }

  const getNumber = (key, fallback = 0) => {
    const raw = get(key)
    const n = Number(raw)
    return Number.isFinite(n) ? n : fallback
  }

  const setNumber = (key, value) => {
    const n = Number(value)
    if (!Number.isFinite(n)) return
    set(key, String(n))
  }

  return { get, set, remove, clear, getJson, setJson, getNumber, setNumber }
}

export const ephemeralStore = createEphemeralStore()
